import React from "react";
import { useNavigate } from "react-router-dom";

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  const handleLogoutProfile = () => {
    navigate("/login");
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="p-2">
        <button
          type="button"
          id="addproductbtn"
          onClick={handleLogoutProfile}
          className="btn btn-dark ms-auto d-block"
        >
          <i className="ng-ng-logout-icon"></i> Logout
        </button>
      </div>
      <div className="d-flex flex-grow-1 align-items-center justify-content-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
              <div className="card mb-0">
                <div className="card-body text-center p-4">
                  <h1 className="text-center">Unauthorized</h1>
                  <p className="text-center">
                    You do not have an account to access this page.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
